<template>
  <app-form-field :id="id" :title="title" :error-message="errorMessage">
    <template #info>
      <slot name="info" />
    </template>
    <input
      v-model="selectedDate"
      :min="minDateFormatted"
      :max="maxDateFormatted"
      type="date"
      :data-qa="id"
      :aria-controls="`${id}-error`"
      :disabled="disabled || null"
      :tabindex="tabindex"
      @keydown.enter.prevent="tabOnEnter && nextField($event.target)"
      @focus="previousDate = selectedDate"
      @blur="checkUnintendedCancel"
    />
  </app-form-field>
</template>

<script>
import moment from 'moment'
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import TabOnEnter from '@/mixins/tabOnEnter.js'

export default {
  components: {
    AppFormField,
  },
  mixins: [TabOnEnter],
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    date: {
      type: [Object, String],
      default: () => {},
    },
    minDate: {
      type: Object,
      default: () => {},
    },
    maxDate: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showUnintendedCancelNotification: {
      type: Boolean,
      default: true,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['changeDate'],
  data() {
    return {
      selectedDate: this.formatToHTML5Date(moment()),
      previousDate: null,
    }
  },
  computed: {
    minDateFormatted() {
      return moment.utc(this.minDate).format(moment.HTML5_FMT.DATE)
    },
    maxDateFormatted() {
      if (!!this.maxDate) {
        return moment.utc(this.maxDate).format(moment.HTML5_FMT.DATE)
      }
      return ''
    },
  },
  watch: {
    date() {
      if (this.date) {
        this.selectedDate = this.formatToHTML5Date(this.date)
      } else if (this.allowEmpty) {
        this.selectedDate = null
      }
    },
  },
  mounted() {
    if (this.date) {
      this.selectedDate = this.formatToHTML5Date(this.date)
    } else if (this.allowEmpty) {
      this.selectedDate = null
    }
  },
  methods: {
    formatToHTML5Date(date) {
      if (moment(date).isValid()) {
        return moment.utc(date).local().format(moment.HTML5_FMT.DATE)
      }
      return ''
    },
    formatStringToMoment() {
      const value = this.selectedDate
      if (!value && this.allowEmpty) return null
      let date = ''
      const regExDDMMYYYY = /([0-3]?\d\-{1})([01]?\d\-{1})([12]{1}\d{3}\.?)/g
      const regExYYYYMMD = /([12]{1}\d{3}\-{1})([01]?\d\-{1})([0-3]?\d)/g
      if (regExDDMMYYYY.test(value)) {
        date = moment.utc(value, 'DD-MM-YYYY')
      } else if (regExYYYYMMD.test(value)) {
        date = moment.utc(value, moment.HTML5_FMT.DATE)
      }
      if (moment(date).isValid()) {
        return date
      }
      return 'INVALID'
    },
    updateField() {
      this.$emit('changeDate', this.formatStringToMoment())
    },
    checkUnintendedCancel() {
      if (this.selectedDate === this.previousDate) {
        if (this.showUnintendedCancelNotification) {
          window.VUE_CLI_EXPORTS.plugins.EventBus.$emit(
            'notification-warning',
            `DateNotChangedWarning`
          )
        }
      } else {
        this.updateField()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
input[type='date'][disabled] {
  pointer-events: auto !important;
  color: #a3b7c0;
  -webkit-text-fill-color: #a3b7c0;
}
</style>
